import { dashboardConstants } from "../_constants";

const {
  GET_ALL_TERMINAL_SUMMARY_START,
  GET_ALL_TERMINAL_SUMMARY_SUCCESS,
  GET_ALL_TERMINAL_SUMMARY_FAILED,
  FILTER_TERMINAL_SUMMARY_FAILED,
  FILTER_TERMINAL_SUMMARY_SUCCESS,
  FILTER_TERMINAL_SUMMARY_START,
} = dashboardConstants;

const initialState = {
  terminalSummaryData: [],
  isLoading: false,
  error: false,
  summaryCount: 0,
  filteredTerminalSummary: [],
};

const DashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_TERMINAL_SUMMARY_START:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ALL_TERMINAL_SUMMARY_SUCCESS:
      const { content, count } = payload;
      return {
        ...state,
        isLoading: false,
        terminalSummaryData: content,
        summaryCount: count,
      };
    case GET_ALL_TERMINAL_SUMMARY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case FILTER_TERMINAL_SUMMARY_START:
      return { ...state, isLoading: true };
    case FILTER_TERMINAL_SUMMARY_SUCCESS:
      const { content: filteredTerminalSummary, count: filteredSummaryCount } =
        payload;
      return {
        ...state,
        isLoading: false,
        terminalSummaryData: filteredTerminalSummary,
        summaryCount: filteredSummaryCount,
      };
    case FILTER_TERMINAL_SUMMARY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export default DashboardReducer;
